module.exports = __webpack_public_path__ + "static/img/icon16.fe66b03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon16.png
// module id = MZOF
// module chunks = 1